import { MaterialDesignContent } from 'notistack';
import styled from 'styled-components';

export const customSnackbar = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#ECFDD8',
    border: '1px solid #B4F389',
    borderLeftWidth: '5px',
    color: '#3B3C40',
    padding: '2px 12px',
    borderRadius: '12px',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      color: '#66D83C',
      marginRight: '8px',
    },
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#FFE4D8',
    border: '1px solid #FF3F49',
    borderLeftWidth: '5px',
    color: '#3B3C40',
    padding: '2px 12px',
    borderRadius: '12px',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      color: '#FF3F49',
      marginRight: '8px',
    },
  },
}));
